import React, { useEffect, useState } from "react";
import {
  getPaymentGovernorates,
  getPaymentDistricts,
  getPaymentVillages,
  getPaymentRegions,
  getPaymentBuild,
  getPaymentPart,
  getPaymentUnit,
  getData,
  getPaymentUnitDetails,
  getPaymentPlaces,
  getPaymentBuildByPlace,
  getPaymentPartByPlace,
} from "../../adapters/apis/lookups/lookups";
import InputElement from "../../shared/form/InputElement";
import styleCorrespondenceData from "./ElectronicPayment.module.css";
import styleProfile from "../../shared/pages/profile/Profile.module.css";
import Lottie from "react-lottie";
import search from "../../lotties/search.json";
import styleBuildingTypeAndUseType from "../taxDeclaration/realEstateData/buildingTypeAndUseType/BuildingTypeAndUseType.module.css";
import stylesModal from "../taxDeclaration/termsConditionsModal/TermsAndConditionsModal.module.css";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import SearchSelectElement from "../../shared/form/SearchSelectElement";

const ElectronicPayment = (props) => {
  Modal.setAppElement("body");
  const [govs, setGovs] = useState([]);
  const [govOptions, setGovOptions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);

  const [villages, setVillages] = useState([]);
  const [villageOptions, setVillageOptions] = useState([]);
  const [streets, setStreets] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);
  const [builds, setBuilds] = useState([]);
  const [buildOptions, setBuildOptions] = useState([]);

  const [parts, setParts] = useState([]);
  const [partOptions, setPartOptions] = useState([]);
  const [units, setUnits] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [gov, setGov] = useState("");
  const [govId, setGovId] = useState(null);
  const [dist, setDist] = useState("");
  const [distId, setDistId] = useState(null);
  const [vil, setVil] = useState("");
  const [vilId, setVilId] = useState(null);
  const [places, setPlaces] = useState([]);
  const [placeOptions, setPlaceOptions] = useState([]);
  const [placeBuildOptions, setPlaceBuildOptions] = useState([]);

  const [place, setPlace] = useState("");
  const [placeId, setPlaceId] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [buildNum, setBuildNum] = useState(null);
  const [str, setStr] = useState("");
  const [strId, setStrId] = useState(null);
  const [buil, setBuil] = useState("");
  const [buildLabel, setBuildLabel] = useState("");

  const [part, setPart] = useState("");
  const [partLabel, setPartLabel] = useState("");

  const [buildPlace, setBuildPlace] = useState("");
  const [buildPlaceLabel, setBuildPlaceLabel] = useState("");

  const [partPlace, setPartPlace] = useState("");
  const [partPlaceLabel, setPartPlaceLabel] = useState("");

  const [unitPlace, setUnitPlace] = useState("");
  const [OWNER_NAME, setOWNER_NAME] = useState(null);
  const [OCCUPANT_NAME, setOCCUPANT_NAME] = useState(null);
  const [CURENT_OWNER, setCURENT_OWNER] = useState(null);
  const [unit, setUnit] = useState("");
  const [unitLabel, setUnitLabel] = useState("");
  const [error, setError] = useState(null);
  const [btn, setbtn] = useState(true);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [paymentId, setPaymentId] = useState("");
  const [accessKey, setAccessKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const customStyles = {
    content: {
      top: "54%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const navigate = useNavigate();
  useEffect(() => {
    getPaymentGovernorates()
      .then((res) => {
        setGovs(res?.data?.data);
        setGovOptions(
          res?.data?.data?.map((element) => {
            return (
              // <option value={ element.id } key={ element.id } name={ element.name }>{ element.name }</option>
              { value: element.id, label: element.name }
            );
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getPaymentPlaces()
      .then((res) => {
        setPlaces(res?.data?.data);
        setPlaceOptions(
          res?.data?.data?.map((element) => {
            return { value: element.id, label: element.name };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: search,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  let builds_options = [];

  builds_options = builds?.map((element) => {
    return { value: element?.build_num, label: element?.build_num };
  });

  const handleChangeGov = (
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) => {
    resetAll();
    //load districts by gov id
    setGov(label);
    setGovId(value);

    setDistrictOptions([]);
    setVillageOptions([]);
    setStreetOptions([]);
    setBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetDistrict(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentDistricts(value)
        .then((res) => {
          setDistricts(res?.data?.data);
          setDistrictOptions(
            res?.data?.data?.map((element) => {
              return { value: element.id, label: element.name };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setDistricts([]);
    }
  };

  function handleChangeDistrict(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by district_id
    setDist(label);
    setDistId(value);
    setVil("");
    setStr("");
    setVilId("");
    setStrId("");
    setBuil("");
    setPart("");
    setUnit("");

    setVillageOptions([]);
    setStreetOptions([]);
    setBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetVillage(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentVillages(value)
        .then((res) => {
          setVillages(res?.data?.villages);
          setVillageOptions(
            res?.data?.villages?.map((element) => {
              return { value: element?.id, label: element?.name };
            })
          );
          setStreets(res?.data?.streets);
          setStreetOptions(
            res?.data?.streets?.map((element) => {
              return { value: element?.id, label: element?.name };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setVillages([]);
    }
  }

  function handleChangeVillage(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by village_id
    setVil(label);
    setVilId(value);
    setStr("");
    setStrId("");
    setBuil("");
    setPart("");
    setUnit("");

    setStreetOptions([]);
    setBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetStreet(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentRegions(value)
        .then((res) => {
          setStreets(res.data.data);
          setStreetOptions(
            res?.data?.data?.map((element) => {
              return { value: element.id, label: element.name };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      handleChangeDistrict("", "", dist, distId);
    }
  }
  function handleChangeRegion(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by village_id
    setStr(label);
    setStrId(value);
    // reset all data
    setBuil("");
    setPart("");
    setUnit("");

    setBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetBuilds(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentBuild(value)
        .then((res) => {
          setBuilds([...new Set(res?.data?.builds)]);
          setBuildOptions(
            res?.data?.builds?.map((element) => {
              return { value: element.id, label: element.build_num };
            })
          );
          setVil(res?.data?.village?.name);
          setVilId(res?.data?.village?.id);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setBuilds([]);
    }
  }

  function handleChangePlace(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    setError(null);
    //load villages by village_id
    setPlace(label);
    setPlaceId(value);
    // reset all data
    setBuildPlace("");
    setPartPlace("");
    setUnitPlace("");

    setPlaceBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);

    // reset next levels
    if (hasChange) {
      resetBuilds(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentBuildByPlace(value)
        .then((res) => {
          // setBuilds([...new Set(res?.data?.builds)]);
          setPlaceBuildOptions(
            res?.data?.builds?.map((element) => {
              return {
                value: element?.id,
                label: element?.build_num,
                region_id: element?.region_id,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setBuilds([]);
    }
  }

  function handleChangeBuild(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by village_id
    setBuil(value);
    setBuildLabel(label);
    setUnit("");

    setPartOptions([]);
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetParts(parentCompenent, compenent);
    }
    if (value !== "") {
      getPaymentPart(value, strId)
        .then((res) => {
          setParts(res.data.parts);
          setPartOptions(
            res?.data?.parts?.map((element) => {
              return { value: element.id, label: element.part_num };
            })
          );
          setPart("");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setParts([]);
      setUnits([]);
    }
  }

  function handleChangeBuildByPlace(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true,
    region_id
  ) {
    setError(null);
    setPartOptions([]);
    setUnitOptions([]);
    setBuildPlace(value);
    setBuildPlaceLabel(label);
    setRegionId(region_id);
    setUnitPlace("");
    // reset next levels
    if (hasChange) {
      resetParts(parentCompenent, compenent);
    }
    if (value !== "") {
      getPaymentPartByPlace(value, region_id)
        .then((res) => {
          setParts(res?.data?.parts);
          setPartOptions(
            res?.data?.parts?.map((element) => {
              return { value: element.id, label: element.part_num };
            })
          );
          setPartPlace("");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setParts([]);
      setUnits([]);
    }
  }
  function handleChangePartByPlace(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    setError(null);
    //load villages by village_id
    setPartPlace(value);
    setPartPlaceLabel(label);
    setUnit("");
    setUnitPlace("");
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetUnits(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentUnit(value, buildPlace, regionId)
        .then((res) => {
          setUnits(res?.data?.data);
          setUnitOptions(
            res?.data?.data?.map((element, index) => {
              return { value: index + 1, label: element.unit_num };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (buil !== "") {
        getPaymentUnit("null", buildPlace, strId)
          .then((res) => {
            setUnits(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      setUnits([]);
    }
  }

  function handleChangeUnitByPlace(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    setError(null);
    setUnitPlace(value);
    setUnitLabel(label);
    setbtn(false);
    // if (value !== "") {
    //   getPaymentUnitDetails(label, buildPlace, regionId)
    //     .then((res) => {
    //       setPartPlace(res.data.part.part_num);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } else {
    //   handleChangeBuild("", "", "", buil);
    // }
  }

  function handleChangePart(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by village_id
    setPart(value);
    setPartLabel(label);
    setUnit("");
    setUnitOptions([]);
    // reset next levels
    if (hasChange) {
      resetUnits(parentCompenent, compenent);
    }

    if (value !== "") {
      getPaymentUnit(value, buil, strId)
        .then((res) => {
          setUnits(res.data.data);
          setUnitOptions(
            res?.data?.data?.map((element, index) => {
              return { value: index + 1, label: element.unit_num };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (buil !== "") {
        getPaymentUnit("null", buil, strId)
          .then((res) => {
            setUnits(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      setUnits([]);
    }
  }
  function handleChangeUnit(
    parentCompenent,
    compenent,
    key,
    value,
    label,
    hasChange = true
  ) {
    //load villages by village_id
    setUnit(value);
    setUnitLabel(label);
    setbtn(false);
    // if (value !== "") {
    //   getPaymentUnitDetails(label, buil, strId)
    //     .then((res) => {
    //       setPart(res.data.part.part_num);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } else {
    //   handleChangeBuild("", "", "", buil);
    // }
  }

  function submitForm(e, enquiry_type) {
    setIsLoading(true);
    e.preventDefault();
    if (enquiry_type === 1) {
      const data = new FormData();
      data.append("enquiry_type", enquiry_type);
      data.append("gov", gov);
      data.append("govId", govId);
      data.append("dist", dist);
      data.append("distId", distId);
      data.append("vil", vil);
      data.append("vilId", vilId);
      data.append("str", str);
      data.append("strId", strId);
      data.append("buil", buildLabel);
      data.append("part", partLabel);
      data.append("unit", unitLabel);
      setOWNER_NAME("");
      setOCCUPANT_NAME("");
      setCURENT_OWNER("");
      if (data !== "") {
        getData(data)
          .then((res) => {
            setIsLoading(false);
            if (!res?.data?.owner_name) {
              if (res?.data?.message) {
                setError(res?.data?.message);
              } else {
                setError("خطأ عام");
              }
            } else {
              setOWNER_NAME(res?.data?.owner_name);
              setOCCUPANT_NAME(res?.data?.occupant_name);
              setCURENT_OWNER(res?.data?.current_owner);
              setPaymentId(res?.data?.payment_id);
              setIsOpen(true);
              setError(null);
            }
          })
          .catch((err) => {
            setError("خطأ عام");
            console.log(err);
          });
      }
    } else if (enquiry_type === 2) {
      const data = new FormData();
      data.append("enquiry_type", enquiry_type);
      data.append("access_key", accessKey);
      if (data !== "") {
        getData(data)
          .then((res) => {
            setIsLoading(false);
            if (!res?.data?.owner_name) {
              if (res?.data?.message) {
                setError(res?.data?.message);
              } else {
                setError("خطأ عام");
              }
            } else {
              setOWNER_NAME(res?.data?.owner_name);
              setOCCUPANT_NAME(res?.data?.occupant_name);
              setCURENT_OWNER(res?.data?.current_owner);
              setPaymentId(res?.data?.payment_id);
              setIsOpen(true);
              setError(null);
            }
          })
          .catch((err) => {
            setError("خطأ عام");
            console.log(err);
          });
      }
    } else {
      const data = new FormData();
      data.append("enquiry_type", enquiry_type);
      data.append("street_id", regionId);
      data.append("buil", buildPlaceLabel);
      data.append("part", partPlaceLabel);
      data.append("unit", unitLabel);
      if (data !== "") {
        getData(data)
          .then((res) => {
            setIsLoading(false);
            if (!res?.data?.owner_name) {
              if (res?.data?.message) {
                setError(res?.data?.message);
              } else {
                setError("خطأ عام");
              }
            } else {
              setOWNER_NAME(res.data?.owner_name);
              setOCCUPANT_NAME(res?.data?.occupant_name);
              setCURENT_OWNER(res?.data?.current_owner);
              setPaymentId(res?.data?.payment_id);
              setIsOpen(true);
              setError(null);
            }
          })
          .catch((err) => {
            setError("خطأ عام");
            console.log(err);
          });
      }
    }
  }

  // reset next levels when you change the governorate
  const resetDistrict = (parentCompenent, compenent) => {
    // reset districts, villages and streets
    setDistricts([]);
    setVillages([]);
    setStreets([]);
  };

  // reset next levels when you change the district
  const resetVillage = (parentCompenent, compenent) => {
    // reset villages and streets
    setVillages([]);
    setStreets([]);
  };

  // reset next levels when you change the village
  const resetStreet = (parentCompenent, compenent) => {
    // reset villages and street
    setStreets([]);
  };
  const resetBuilds = (parentCompenent, compenent) => {
    // reset villages and street
    setBuilds([]);
  };
  const resetParts = (parentCompenent, compenent) => {
    // reset villages and street
    setParts([]);
  };
  const resetUnits = (parentCompenent, compenent) => {
    // reset villages and street
    setUnits([]);
  };

  const resetAll = (parentCompenent, compenent) => {
    setError(null);
    setUnits([]);
    // setStreets([]);
    setBuilds([]);
    setParts([]);
    // setDistricts([]);
    // setVillages([]);
    setDist("");
    setGov("");
    setGovId("");
    setDistId("");
    setVil("");
    setVilId("");
    setUnit("");
    setPart("");
    setBuil("");
    setStr("");
    setStrId("");
    setAccessKey("");
    setPlace("");
    setPlaceId("");
    setUnitPlace("");
    setPartPlace("");
    setBuildPlace("");
  };

  const handleChangeTabs = () => {
    resetAll();

    setPlaceBuildOptions([]);
    setPartOptions([]);
    setUnitOptions([]);

    setDistrictOptions([]);
    setVillageOptions([]);
    setStreetOptions([]);
    setBuildOptions([]);
  };

  const addressHandleSubmit = async (e) => {
    if (
      gov === "" ||
      dist === "" ||
      vil === "" ||
      str === "" ||
      buil === "" ||
      part === "" ||
      unit === ""
    ) {
      setError(
        "من فضلك املأ البيانات التالية حتى يتسنى لنا اظهار كود حساب الوحدة الخاص بك "
      );
      setbtn(true);
    } else if (OWNER_NAME === " ") {
    } else {
      submitForm(e, 1);
      //setOpenModal("#electronic-model");
    }
    //e.preventDefault();
  };

  const handleAccessSubmit = async (e) => {
    e.preventDefault();
    if (accessKey === "") {
      setError(
        "من فضلك املأ البيانات التالية حتى يتسنى لنا اظهار كود حساب الوحدة الخاص بك "
      );
    } else {
      submitForm(e, 2);
    }
  };

  const northCoastHandleSubmit = async (e) => {
    if (
      place === "" ||
      buildPlace === "" ||
      partPlace === "" ||
      unitPlace === ""
    ) {
      setError(
        "من فضلك املأ البيانات التالية حتى يتسنى لنا اظهار كود حساب الوحدة الخاص بك "
      );
      setbtn(true);
    } else {
      submitForm(e, 3);
    }
  };

  const handelNavigate = () => {
    navigate("/online-payment/confirm/" + paymentId);
  };
  function closeModal() {
    setIsOpen(false);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function handleChange(parentCompenent, compenent, name, value) {
    const regex = /^[0-9]*$/;
    if (!regex.test(value)) {
      setError("الكود يجب أن يتكون من أرقام فقط، برجاء إدخال الكود الصحيح");
    } else {
      setError(null);
    }
    setAccessKey(value);
  }
  return (
    <>
      {error !== null && (
        <div className="alert alert-danger m-0" role="alert">
          {error}
        </div>
      )}
      <div className="box">
        <h4
          className={`${styleCorrespondenceData["box-title"]} box-title mb-4`}
        >
          بيانات العقار
        </h4>

        <ul className="nav nav-tabs" id="myTab">
          {/* Don't forget to unComment the tab content */}
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="north_coast_tab"
              data-bs-toggle="tab"
              data-bs-target="#north-coast"
              type="button"
              role="tab"
              aria-controls="north-coast"
              aria-selected="true"
              onClick={() => handleChangeTabs()}
            >
              استعلام الساحل الشمالي
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="address-tab"
              data-bs-toggle="tab"
              data-bs-target="#address"
              type="button"
              role="tab"
              aria-controls="address"
              aria-selected="false"
              onClick={() => handleChangeTabs()}
            >
              استعلام بالعنوان التفصيلي
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link" // commented this line, when commenting north_coast, and address tabs
              // className="nav-link active"
              id="access_key_tab"
              data-bs-toggle="tab"
              data-bs-target="#access_key"
              type="button"
              role="tab"
              aria-controls="access_key"
              aria-selected="false"
              onClick={() => handleChangeTabs()}
            >
              استعلام بكود حساب الوحدة
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          {/* should be uncommented when adding the tabs back */}
          <div
            className="tab-pane fade show active"
            id="north-coast"
            role="tabpanel"
            aria-labelledby="north_coast_tab"
          >
            <div className="mt-4">
              <form onSubmit={addressHandleSubmit} id="north_coast_form">
                <div className="row">
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="place_id"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="القرية"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="place_id"
                      inputId="place_id_north_input"
                      name="place_id"
                      options={placeOptions}
                      default="القرية"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangePlace}
                      payment="1"
                      value={placeId}
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="build_id"
                      inputType="text"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="رقم العقار / رقم القطعة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="build_id"
                      inputId="build_id_north_input"
                      name="build_id"
                      options={placeBuildOptions}
                      default="رقم العقار / رقم القطعة"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeBuildByPlace}
                      tooltipText="في حالة عدم الاستدلال على رقم الوحدة الخاص بك يرجي البحث علي رقم الوحدة في ارقام العقارات المتاحة"
                      value={buildPlace}
                      type="string"
                      northCoast={true}
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      name="part_id"
                      mb4="mb-4"
                      labelHtmlFor="part_id"
                      labelClassName={`${styleCorrespondenceData["form-label"]} form-label`}
                      labelText="رقم الدور"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="part_id"
                      inputId="part_id_north_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      options={partOptions}
                      default="رقم الدور"
                      onChange={handleChangePartByPlace}
                      payment="1"
                      value={partPlace ? partPlace : ""}
                      type="string"
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="unit_id"
                      labelClassName={`${styleCorrespondenceData["form-label"]} form-label`}
                      labelText="رقم الوحدة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="unit_id"
                      inputId="unit_id_north_input"
                      name="unit_id"
                      options={unitOptions}
                      default="رقم الوحدة"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText=""
                      value={unitPlace ? unitPlace : ""}
                      onChange={handleChangeUnitByPlace}
                      payment="1"
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 css-14el2xx-placeholder">
                    فى حال وجود اى إستفسار يرجى التواصل مع المأمورية التابع لها
                  </div>
                </div>
                <div className="btn-myProfile d-flex justify-content-start flex-md-row flex-column gap-lg-5 gap-3  align-items-center mt-4">
                  {/* {place === "" || buildPlace === "" || partPlace === "" || unitPlace === "" ? (
                    <button
                      type="button"
                      className={`${styleProfile["btn-edit"]} btn-edit`}
                      onClick={northCoastHandleSubmit}
                      id="north_coast_form_submit_check"
                    >
                      إرسال بيانات العقار
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={`${styleProfile["btn-edit"]} btn-edit`}
                      onClick={(e) => submitForm(e, 3)}
                      id="north_coast_form_submit"
                    >
                      إرسال بيانات العقار
                    </button>
                  )} */}

                  <button
                    type="button"
                    className={`${styleProfile["btn-edit"]} btn-edit`}
                    onClick={(e) => submitForm(e, 3)}
                    id="north_coast_form_submit_check"
                    disabled={
                      place === "" ||
                      buildPlace === "" ||
                      partPlace === "" ||
                      unitPlace === "" ||
                      isLoading
                    }
                  >
                    إرسال بيانات العقار
                  </button>
                  <button
                    type="button"
                    onClick={resetAll}
                    className={styleProfile["btn-cancle"]}
                    id="north_coast_form_clear"
                  >
                    مسح
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="address"
            role="tabpanel"
            aria-labelledby="address-tab"
          >
            <div className="mt-4">
              <form onSubmit={addressHandleSubmit} id="address_form">
                <div className="row">
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="governorate_id"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="المحافظة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="governorate_id"
                      inputId="governorate_id_input"
                      name="governorate_id"
                      options={govOptions}
                      default="أختار المحافظة .."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeGov}
                      value={govId}
                      payment="1"
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="district_id"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="المأمورية / القسم"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="district_id"
                      inputId="district_id_input"
                      name="district_id"
                      options={districtOptions}
                      default="أختار المأمورية / القسم  .."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeDistrict}
                      value={distId}
                      payment="1"
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="village_id"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="المنطقة / الشياخة / التجمع السكنى"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="village_id"
                      inputId="village_id_input"
                      name="village_id"
                      options={villageOptions}
                      default="أختار المنطقة / الشياخة / التجمع السكنى..."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeVillage}
                      payment="1"
                      value={vilId ? vilId : ""}
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="street_id"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="أسم الشارع / المجاورة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="street_id"
                      inputId="street_id_input"
                      name="street_id"
                      options={streetOptions}
                      default="أختار أسم الشارع / المجاورة...."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeRegion}
                      payment="1"
                      value={strId}
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="build_id"
                      inputType="text"
                      labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                      labelText="رقم العقار / رقم القطعة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="build_id"
                      inputId="build_id_input"
                      name="build_id"
                      options={buildOptions}
                      default="رقم العقار / رقم القطعة"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeBuild}
                      payment="1"
                      tooltipText="في حالة عدم الاستدلال على رقم الوحدة الخاص بك يرجي البحث علي رقم الوحدة في ارقام العقارات المتاحة"
                      value={buil}
                      type="string"
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      name="part_id"
                      mb4="mb-4"
                      labelHtmlFor="part_id"
                      labelClassName={`${styleCorrespondenceData["form-label"]} form-label`}
                      labelText="رقم الدور"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="part_id"
                      inputId="part_id_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      options={partOptions}
                      default="رقم الدور"
                      onChange={handleChangePart}
                      payment="1"
                      value={part ? part : ""}
                      type="string"
                    />
                  </div>
                  <div className="col-md-3">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="unit_id"
                      labelClassName={`${styleCorrespondenceData["form-label"]} form-label`}
                      labelText="رقم الوحدة"
                      selectClassName={`${styleCorrespondenceData["form-select"]} form-select`}
                      selectID="unit_id"
                      inputId="unit_id_input"
                      name="unit_id"
                      options={unitOptions}
                      default="رقم الوحدة"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText=""
                      value={unit ? unit : ""}
                      onChange={handleChangeUnit}
                      payment="1"
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 css-14el2xx-placeholder">
                    فى حال وجود اى إستفسار يرجى التواصل مع المأمورية التابع لها
                  </div>
                </div>
                <div className="btn-myProfile d-flex justify-content-start flex-md-row flex-column gap-lg-5 gap-3  align-items-center mt-4">
                  {/* {gov === "" ||
                  dist === "" ||
                  vil === "" ||
                  str === "" ||
                  buil === "" ||
                  part === "" ||
                  unit === "" ? (
                    <button
                      type="button"
                      className={`${styleProfile["btn-edit"]} btn-edit`}
                      onClick={addressHandleSubmit}
                      id="address_form_submit_check"
                      // disabled={btn}
                    >
                      إرسال بيانات العقار
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={`${styleProfile["btn-edit"]} btn-edit`}
                      onClick={(e) => submitForm(e, 1)}
                      id="address_form_submit"
                    >
                      إرسال بيانات العقار
                    </button>
                  )} */}

                  <button
                    type="button"
                    className={`${styleProfile["btn-edit"]} btn-edit`}
                    onClick={(e) => submitForm(e, 1)}
                    id="address_form_submit"
                    disabled={
                      gov === "" ||
                      dist === "" ||
                      vil === "" ||
                      str === "" ||
                      buil === "" ||
                      part === "" ||
                      unit === "" ||
                      isLoading
                    }
                  >
                    إرسال بيانات العقار
                  </button>
                  <button
                    type="button"
                    onClick={resetAll}
                    className={styleProfile["btn-cancle"]}
                    id="address_form_clear"
                  >
                    مسح
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            className="tab-pane fade" // commented this line, when commenting north_coast, and address tabs
            // className="tab-pane fade show active"
            id="access_key"
            role="tabpanel"
            aria-labelledby="access_key_tab"
          >
            <div className="mt-4">
              <form onSubmit={handleAccessSubmit} id="access_key_form">
                <div className="col-md-3">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="access_key"
                    labelClassName={`form-label ${styleCorrespondenceData["form-label"]}`}
                    labelText="كود حساب الوحدة"
                    inputClassName={`${styleCorrespondenceData["form-control"]} form-control`}
                    inputID="access_key"
                    name="access_key"
                    default="كود حساب الوحدة"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    payment="1"
                    inputType="text"
                    onChange={handleChange}
                    value={accessKey}
                  />
                </div>
                <div className={`${styleProfile["submit-button"]}`}>
                  <button
                    type="submit"
                    className={`${styleProfile["btn-edit"]} btn-edit`}
                    disabled={
                      accessKey === "" ||
                      !/^[0-9]*$/.test(accessKey) ||
                      isLoading
                    }
                    id="access_key_form_submit"
                  >
                    إرسال بيانات العقار
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          className={`${styleBuildingTypeAndUseType["ReactModal"]} w-90`}
          contentLabel="Example Modal"
        >
          <div
            className={`${styleBuildingTypeAndUseType["modal-confirm"]}  ${styleCorrespondenceData["modal-xl"]}`}
          >
            <div
              className={`${styleBuildingTypeAndUseType["modal-dialog"]} modal-dialog modal-dialog-centered`}
            >
              <div
                className={`${styleBuildingTypeAndUseType["modal-content"]} modal-content`}
              >
                <div
                  className={`${styleBuildingTypeAndUseType["modal-header"]} ${styleCorrespondenceData["modal-header"]} modal-header`}
                >
                  <Lottie options={defaultOptions} />
                </div>

                <div
                  className={`${styleBuildingTypeAndUseType["modal-body"]} modal-body pb-4`}
                >
                  {error !== null && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-10">
                      <InputElement
                        name="first_name"
                        mb4="mb-4"
                        labelHtmlFor="first_name"
                        labelClassName={` ${styleCorrespondenceData["form-label"]} form-label`}
                        labelText="أسم الشاغل"
                        inputType="text"
                        inputClassName={`${styleCorrespondenceData["form-control"]} form-control`}
                        inputID="occupant_name"
                        value={OCCUPANT_NAME ? OCCUPANT_NAME : ""}
                        disabled={true}
                      />
                      <InputElement
                        name="name_of_owner"
                        mb4="mb-4"
                        labelHtmlFor="name_of_owner"
                        labelClassName={` ${styleCorrespondenceData["form-label"]} form-label`}
                        labelText="أسم المالك / المنتفع"
                        inputType="text"
                        inputClassName={`${styleCorrespondenceData["form-control"]} form-control`}
                        inputID="name_of_owner"
                        value={CURENT_OWNER ? CURENT_OWNER : ""}
                        disabled={true}
                      />
                      <InputElement
                        name="name_of_assignee"
                        mb4="mb-4"
                        labelHtmlFor="name_of_assignee"
                        labelClassName={` ${styleCorrespondenceData["form-label"]} form-label`}
                        labelText="أسم صاحب التكليف"
                        inputType="text"
                        inputClassName={`${styleCorrespondenceData["form-control"]} form-control`}
                        inputID="name_of_assignee"
                        value={OWNER_NAME ? OWNER_NAME : ""}
                        disabled={true}
                      />
                    </div>
                    {/* <div className="col-md-1"></div> */}

                    <div className="list-group border-0 mt-3">
                      <label
                        className={`${stylesModal["list-group-item"]} list-group-item border-0`}
                      >
                        <span
                          className={`${styleCorrespondenceData["form-check-input"]} `}
                        >
                          برجاء الإقرار بالتأكيد في حال صحة البيانات , و إدخال
                          بيانات الشخصية لصاحب العقار في الخطوة التالية
                        </span>
                      </label>
                    </div>

                    <div
                      className={`d-flex justify-content-start justify-content-md-center flex-md-row flex-column gap-lg-5 gap-3 align-items-center mt-4`}
                    >
                      <button
                        type="button"
                        disabled={error ? true : ""}
                        className={`${styleCorrespondenceData["btn-edit"]} `}
                        onClick={handelNavigate}
                        data-bs-target="#electronic-model"
                        id="data_confirmation_button"
                      >
                        تأكيد البيانات
                      </button>
                      <button
                        type="button"
                        className={styleCorrespondenceData["btn-cancle"]}
                        onClick={closeModal}
                        id="cancel_button"
                      >
                        إلغاء
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default ElectronicPayment;
